import React, { useState } from 'react'
import { IFaq } from '@et/types/Courses'
import IFaqItem from './faqItem'
import { VerticalWrapper } from '@styles/global/helpers'
import { GridFluid } from '@styles/global/cssGrid'
import VerticalCategory from '@components/dividers/verticalCategory'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'

interface IProps {
  faqs: IFaq[]
  textColor?: string
  textActivatedColor?: string
  activeBgColor?: string
}

type State = null | number

function Faq ({ faqs, textColor, textActivatedColor, activeBgColor }: IProps) {
  const [selectedItem, setSelectedItem] = useState<State>(null)

  function handleItemClick (itemIndex?: number | null) {
    if (itemIndex || itemIndex === 0) {
      setSelectedItem(itemIndex)
    } else {
      setSelectedItem(null)
    }
  }

  return (
    <VerticalWrapper>
      <GridFluid>
        <VerticalCategory text={`Frequently  Asked  Questions`}/>
        <FaqWrapper>
          {faqs && faqs.map((faq: IFaq, index: number) => (
            <IFaqItem
              activeBgColor={activeBgColor}
              textColor={textColor}
              textActivatedColor={textActivatedColor}
              key={index}
              itemIndex={index}
              handleClick={handleItemClick}
              selectedItem={selectedItem}
              {...faq}
            />
          ))}
        </FaqWrapper>
      </GridFluid>
    </VerticalWrapper>
  )
}

const FaqWrapper = styled.div`
  grid-column: 2 / -1;
  padding-left: 30px;
  
  @media ${device.tablet}{
    padding-left: 0;
    grid-column: 4 / -1;
    padding-bottom: 80px;
  }
`
export default Faq
